
import React from 'react'
import OnVisible from 'react-on-visible'
import { Section } from 'newComponents'
import './styles.scss'

const AnchorTitle = (props) => {
  const { data, location } = props
  const { primary } = data
  const { is_child: isChild, title } = primary

  const titleHtml = title?.html
  const titleText = title?.text
  const childAnchor = isChild ? 'is-child' : ''
  const anchorId = titleText ? titleText.replace(/\s+/g, '-').toLowerCase() : ''


  return (
    <OnVisible className={`anchor-title ${childAnchor}`} id={anchorId}>
      <Section noWrapper>
        {titleHtml && <div className="anchor-title-text" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
      </Section>
    </OnVisible>
  )
}

export default AnchorTitle
